module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-edit-collection vh-100 w-full overflow-y-scroll pa4 row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-3 pa0"
  }, [_c('div', {
    key: _vm.collection.name,
    staticClass: "w-100 flex align-center"
  }, [_c('span', {
    staticClass: "collection-name"
  }, [_vm._v(_vm._s(_vm.collection.name))]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-small pl-icon ml1",
    nativeOn: {
      "click": function($event) {
        return _vm.editCategoryName()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })])], 1), _vm._v(" "), _c('a', {
    staticClass: "link w-100",
    on: {
      "click": function($event) {
        return _vm.goToUniverse()
      }
    }
  }, [_vm._v(" See in Universe ")]), _vm._v(" "), _c('div', {
    staticClass: "ml1 pl-color-ruby",
    staticStyle: {
      "margin-left": "0",
      "margin-top": "20px"
    }
  }, [_vm._v("\n      (a position of 0 will exclude it from the universe home page)\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 default-position",
    staticStyle: {}
  }, [_c('span', {
    staticClass: "section-header mv0 mr2"
  }, [_vm._v("Default Position: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.collection.position),
      expression: "collection.position"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.collection, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.nCategories), function(position) {
    return _c('option', {
      key: 'pos' + position,
      domProps: {
        "value": position
      }
    }, [_vm._v("\n          " + _vm._s(position) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('span', {
    staticClass: "section-header"
  }, [_vm._v("Description: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.collection.description),
      expression: "collection.description"
    }],
    staticClass: "mt1",
    staticStyle: {
      "width": "100%",
      "height": "150px",
      "resize": "none"
    },
    domProps: {
      "value": (_vm.collection.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.collection, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('span', {
    staticClass: "section-header"
  }, [_vm._v("Subject Areas:")]), _vm._v(" "), _c('multiselect', {
    staticClass: "mt2",
    attrs: {
      "options": _vm.subjects,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "Select subjects",
      "label": "name",
      "track-by": "id",
      "preselect-first": true
    },
    model: {
      value: (_vm.selectedSubjects),
      callback: function($$v) {
        _vm.selectedSubjects = $$v
      },
      expression: "selectedSubjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4 dib"
  }, [_c('span', {
    staticClass: "section-header"
  }, [_vm._v("Grades:")]), _vm._v(" "), _c('div', {
    staticClass: "grades"
  }, _vm._l((_vm.gradeLevels), function(grade, gradeIndex) {
    return _c('div', {
      key: grade + gradeIndex,
      staticClass: "grade mt2"
    }, [_c('pl-checkbox', {
      attrs: {
        "value": grade.id
      },
      model: {
        value: (_vm.selectedGradeLevels),
        callback: function($$v) {
          _vm.selectedGradeLevels = $$v
        },
        expression: "selectedGradeLevels"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(grade.grade))])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "w-100 mt4"
  }, [_c('span', {
    staticClass: "section-header"
  }, [_vm._v("Tags:")]), _vm._v(" "), _c('div', {
    staticClass: "mt2"
  }, [_c('multiselect', {
    attrs: {
      "tag-placeholder": "Add this as new tag",
      "placeholder": "Search or add a tag",
      "label": "name",
      "track-by": "id",
      "options": _vm.suggestedTags,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag,
      "search-change": function($event) {
        return _vm.searchTags($event)
      }
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-9 pa0 right-section"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.saveCategory()
      }
    }
  }, [_vm._v("SAVE COLLECTION\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl6 mt3"
  }, [_c('draggable', {
    staticClass: "list-group",
    attrs: {
      "list": _vm.premades,
      "disabled": !_vm.enabled,
      "ghost-class": "ghost"
    },
    on: {
      "start": function($event) {
        _vm.dragging = true
      },
      "end": function($event) {
        _vm.dragging = false
      }
    }
  }, _vm._l((_vm.premades), function(p) {
    return _c('div', {
      key: p.name,
      staticClass: "list-group-item col-xs-12 pt3 cursor-move border-b"
    }, [_c('span', {
      staticClass: "pl-premade-title"
    }, [_vm._v(_vm._s(p.title))]), _vm._v(" "), _c('div', {
      staticClass: "pb3 pt1"
    }, [_c('a', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.gotToRoundtable(p.id)
        }
      }
    }, [_vm._v("\n              Go to Roundtable\n            ")])])])
  }), 0)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-60f1e961!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminEditCollection.vue
// module id = 1948
// module chunks = 61